export default "__VITE_ASSET__DBxNJtTj__"